export default "__VITE_ASSET__CFxDr_26__"